import React from "react";
import { Phone, CalendarClock, Gift } from "lucide-react";
import { BUSINESS } from "@/lib/api";
import { useT } from "@/lib/i18n";
import VoucherDialog from "@/components/site/VoucherDialog";

/**
 * Sticky bottom CTA bar shown only on mobile.
 * Three actions: Call · Schedule · $10 off
 */
export default function MobileCTABar() {
  const { t } = useT();
  return (
    <div
      data-testid="mobile-cta-bar"
      className="lg:hidden fixed bottom-3 inset-x-3 z-40 rounded-full bg-brand-navy/95 backdrop-blur-xl shadow-2xl border border-white/10 px-1 py-1 flex items-center gap-1"
    >
      <a
        href={`tel:${BUSINESS.phoneTel}`}
        data-testid="mobile-cta-call"
        className="flex-1 flex flex-col items-center justify-center py-2 rounded-full hover:bg-white/10 transition-colors text-white"
      >
        <Phone className="h-4 w-4" />
        <span className="text-[11px] font-semibold mt-0.5">{t("cta.call")}</span>
      </a>
      <a
        href="#schedule"
        data-testid="mobile-cta-schedule"
        className="flex-1 flex flex-col items-center justify-center py-2 rounded-full bg-brand-blue hover:bg-sky-500 transition-colors text-white"
      >
        <CalendarClock className="h-4 w-4" />
        <span className="text-[11px] font-semibold mt-0.5">
          {t("cta.scheduleShort")}
        </span>
      </a>
      <VoucherDialog
        testIdPrefix="mobile-bar-voucher"
        trigger={
          <button
            data-testid="mobile-cta-voucher"
            className="flex-1 flex flex-col items-center justify-center py-2 rounded-full hover:bg-white/10 transition-colors text-amber-300"
          >
            <Gift className="h-4 w-4" />
            <span className="text-[11px] font-semibold mt-0.5">
              {t("cta.tenOff")}
            </span>
          </button>
        }
      />
    </div>
  );
}
